<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <section class="add-course-section admin-add-course-section mt-4_5">
      <h4 class="title squiggly-line-color line-center">
        {{ edit ? "Edit" : "Add a" }} Course
      </h4>
      <b-form-group
              label=""
              v-if="!edit"
              class="type-switch"
              :class="switched ? 'switched' : ''"
      >
        <h6 class="m-3 text-center"> Course Type </h6>
        <b-form-radio-group>
          <b-form-radio
                  type="radio"
                  v-model="picked"
                  value="regular"
                  name="Regular Course"
                  @change="hideRadio"
          >
            <font-awesome-icon icon="book" class="mr-2"/>
            Regular Course
          </b-form-radio>

          <b-form-radio
                  type="radio"
                  v-model="picked"
                  value="live"
                  name="Live Course"
                  @change="hideRadio"
          >
            <font-awesome-icon
                    icon="broadcast-tower"
                    class="mr-2"
            />
            Live Course
          </b-form-radio>
        </b-form-radio-group>
      </b-form-group>
      <div class="add-course-wrapper">
        <b-form
          v-if="show && switched"
          data-vv-scope="addCourse"
          @submit.prevent="action('addCourse')"
        >
          <b-form-group
            id="input-group-file"
            label=""
            label-for="input-file"
            description=""
          >
            <div class="course-cover-image mb-4" style="position: relative">
              <img
                :src="courseData.imageUrl"
                alt=""
                style="height:300px;width:100%"
              />
              <button
                class="btn-danger"
                style="position: absolute ; top: 1px; right: 1px;"
                @click="
                  showFile = true;
                  courseData.imageUrl = '';
                "
                v-if="!showFile"
              >
                <font-awesome-icon :icon="['far', 'edit']" />
                Edit Cover Image
              </button>
              <b-form-file
                v-if="showFile"
                id="input-file"
                :state="Boolean(file)"
                v-model="file"
                accept="image/*"
                placeholder="Choose a cover image"
                drop-placeholder="Drop file here..."
                v-validate="'required|image'"
                :class="{ 'is-invalid': errors.has('addCourse.Cover Image') }"
                name="Cover Image"
                @change="uploadCoverImage"
              ></b-form-file>
              <!--            after choosing change placeholder to Change cover image-->
              <b-form-invalid-feedback
                style="position: absolute ; top: 300px ; right: 1px;display: block"
                id="add-course-error-feedback"
              >
                <small>{{ errors.first("addCourse.Cover Image") }}</small>
              </b-form-invalid-feedback>
            </div>
          </b-form-group>
          <div class="row">
            <b-form-group
              v-if="!edit"
              id="input-group-3"
              label="Category"
              label-for="input-3"
              class="col-6"
            >
              <v-select
                v-model="courseData.category"
                :close-on-select="true"
                placeholder="Category"
                :options="categories"
                label="category_name"
                name="Course Category"
                v-validate="'required'"
                :class="{
                  'is-invalid': errors.has('addCourse.Course Category')
                }"
              />
              <b-form-invalid-feedback
                id="add-course-error-feedback"
                style="display: block"
              >
                <small>{{ errors.first("addCourse.Course Category") }}</small>
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              v-if="edit"
              id="input-group-1"
              label="Course Category"
              label-for="input-1"
              description=""
              class="col-6"
            >
              <b-form-input
                id="input-1"
                v-model="courseData.categoryId"
                type="text"
                disabled
                placeholder="Title"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-1"
              label="Title"
              label-for="input-1"
              description=""
              class="col-6"
            >
              <b-form-input
                id="input-1"
                v-model="courseData.name"
                type="text"
                required
                placeholder="Title"
                v-validate="
                  'required|regex:^[A-Za-z0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _-]*$'
                "
                :class="{ 'is-invalid': errors.has('addCourse.Course Name') }"
                name="Course Name"
              ></b-form-input>
              <b-form-invalid-feedback id="add-course-error-feedback">
                <small>{{ errors.first("addCourse.Course Name") }}</small>
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              v-if="picked === 'live'"
              id="input-group-1"
              label="Total Session"
              label-for="input-2"
              description=""
              class="col-6"
            >
              <b-form-input
                id="input-2"
                v-model="courseData.totalSession"
                type="text"
                required
                placeholder="Total Session"
                v-validate="'required|regex:^0*[1-9]\\d*$'"
                :class="{ 'is-invalid': errors.has('addCourse.Total Session') }"
                name="Total Session"
              ></b-form-input>
              <b-form-invalid-feedback id="add-course-error-feedback">
                <small>{{ errors.first("addCourse.Total Session") }}</small>
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              v-if="picked === 'regular'"
              id="input-group-1"
              label="Total Videos"
              label-for="input-3"
              description=""
              class="col-6"
            >
              <b-form-input
                id="input-3"
                v-model="courseData.totalVideos"
                type="text"
                required
                placeholder="Total Videos"
                v-validate="'required|regex:^0*[1-9]\\d*$'"
                :class="{ 'is-invalid': errors.has('addCourse.Total Videos') }"
                name="Total Videos"
              ></b-form-input>
              <b-form-invalid-feedback id="add-course-error-feedback">
                <small>{{ errors.first("addCourse.Total Videos") }}</small>
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              id="input-group-1"
              label="Price"
              label-for="input-4"
              description=""
              class="col-6"
            >
              <b-form-input
                id="input-4"
                v-model="courseData.price"
                type="text"
                required
                placeholder="Price"
                v-validate="'required|regex:^0*[1-9]\\d*$'"
                :class="{ 'is-invalid': errors.has('addCourse.price') }"
                name="price"
              ></b-form-input>
              <b-form-invalid-feedback id="add-course-error-feedback">
                <small>{{ errors.first("addCourse.price") }}</small>
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              id="input-group-1"
              label="Duration"
              label-for="input-5"
              description="How many days,weeks or months required to finish course ??"
              class="col-6"
            >
              <b-form-input
                id="input-5"
                v-model="courseData.duration"
                type="text"
                required
                placeholder="Duration"
                v-validate="
                  'required|regex:^[A-Za-z0-9 _-]*[1-9][A-Za-z0-9 _-]*$'
                "
                :class="{ 'is-invalid': errors.has('addCourse.Duration') }"
                name="Duration"
                @blur="appendDuration"
              ></b-form-input>
              <b-form-invalid-feedback id="add-course-error-feedback">
                <small>{{ errors.first("addCourse.Duration") }}</small>
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              id="input-group-desc"
              label="Description"
              label-for="input-desc"
              description=""
              class="col-6"
            >
              <b-form-textarea
                id="textarea"
                v-model="courseData.description"
                placeholder="Add Description here"
                rows="3"
                max-rows="6"
                v-validate="'required|min:20'"
                :class="{ 'is-invalid': errors.has('addCourse.Description') }"
                name="Description"
              ></b-form-textarea>
              <b-form-invalid-feedback id="add-course-error-feedback">
                <small>{{ errors.first("addCourse.Description") }}</small>
              </b-form-invalid-feedback>
            </b-form-group>
            <property-template
              :property-keys="propertyKeys"
              :show-prop-error="showPropError"
              :show-error="showError"
              :properties="courseData.courseProperties"
              @updateProperties="updateProperties"
            />
            <div class="col-12">
              <b-input-group
                class="multi-input-form mb-4"
                id="input-group-7"
                label="Course Speciality"
                label-for="input-7"
              >
                <b-form-input
                  id="input-7"
                  v-model="text"
                  placeholder="Speciality"
                  v-on:keyup.enter="validateSpeciality"
                  name="Speciality"
                  :class="{ 'is-invalid': errors.has('Speciality') }"
                ></b-form-input>
                <b-input-group-append>
                  <b-button variant="primary" @click="validateSpeciality"
                    >
                    <font-awesome-icon
                            icon="plus"
                    /></b-button
                ></b-input-group-append>
              </b-input-group>
              <b-form-invalid-feedback id="add-course-error-feedback" v-if="showError && courseData.courseSpeciality.length <= 0" style="display: block"  >
                <small>Course Speciality is Required</small>
              </b-form-invalid-feedback>
              <b-form-invalid-feedback id="add-course-error-feedback" style="display: block">
                <small>{{ errors.first("Speciality") }}</small>
              </b-form-invalid-feedback>
              <b-list-group class="mb-3">
                <b-list-group-item
                  v-for="(speciality, i) in courseData.courseSpeciality"
                  :key="i"
                >
                  <div class="row li-items">
                    <b-col cols="1">
                      {{(i+1)}}
                    </b-col>
                    <b-col class="col-10">
                      <p class="mb-0">{{ speciality }}</p></b-col
                    >
                    <b-col class="col-1"
                      ><div
                        class="delete"
                        @click="removeFromCourseSpeciality(i)"
                      >
                        <font-awesome-icon icon="trash"></font-awesome-icon>
                        <span class="ml-2">Delete</span>
                      </div></b-col
                    >
                  </div>
                </b-list-group-item>
              </b-list-group>
            </div>
          </div>
          <b-button
            size="lg"
            pill
            variant="primary"
            @click="action('addCourse')"
            :disabled="disableButton"
          >
            <span>Next</span>
            <font-awesome-icon icon="arrow-right" size="xs" />
          </b-button>
          <!--        <b-button type="reset" variant="danger">Reset</b-button>-->
        </b-form>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { courseEntityApi } from "../../services/adminApis/CourseEntityApi";
import { fileUploadApis } from "../../services/adminApis/fileUploadApis";
import { regularCourseJs } from "../../Commonjs/adminCourse/regularCourse";
import { liveCourseJs } from "../../Commonjs/adminCourse/liveCourse";
import { liveCourseEntity } from "../../services/adminApis/liveCourseEntityApi";
import PropertyTemplate from "../components/propertyTemplate";

export default {
  components: { PropertyTemplate },
  name: "AddCourse",
  data() {
    return {
      courseData: {
        name: "",
        totalSession: "",
        duration: "",
        imageUrl: "",
        totalVideos: "",
        price: "",
        subject: "",
        description: "",
        courseProperties: [],
        language: "",
        courseSpeciality: [],
        category: null
      },
      picked: "regular",
      categories: [],
      propertyKeys: ["Subject", "Medium of Instruction"],
      switched: false,
      show: true,
      file: "",
      text: "",
      textEmpty: false,
      token: "",
      showError: false,
      showPropError: false,
      propertyValue: "",
      showFile: true,
      disableButton: false,
      edit: false,
    };
  },
  computed: {
    ...mapGetters("category", ["getCategoryData"]),
    ...mapGetters("adminAuth", ["getToken"])
  },
    created(){
        this.$validator.attach({ name :'Speciality', rules :'required'});
    },
  methods: {
      validateSpeciality() {
          this.$validator.validate('Speciality', this.text).then( result => {
             if(result) this.addToCourseSpeciality();
          });
      },
      appendDuration(){
          this.courseData.duration = this.courseData.duration.trim();
          if(this.courseData.duration.length <= 1)  this.courseData.duration = this.courseData.duration + ' Days';
      },
    action(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (
          result &&
          this.courseData.courseProperties.length > 0 &&
          this.courseData.courseSpeciality.length > 0
        ) {
          this.showError = false;
          this.course();
        } else if (
          this.courseData.courseProperties.length === 0 &&
          this.courseData.courseSpeciality.length === 0
        ) {
          this.showPropError = true;
          this.textEmpty = true;
          this.showError = true;
        } else if (this.courseData.courseProperties.length === 0) {
          this.showPropError = true;
          this.showError = true;
        } else if (this.courseData.courseSpeciality.length === 0) {
          this.textEmpty = true;
          this.showError = true;
        } else {
          this.showError = true;
        }
      });
    },
    async course() {
      if (this.$route.query.courseId) {
        if (this.picked === "regular") {
            try {
                const res = await regularCourseJs.editCourse(
                    this.courseData,
                    this.getToken
                );
                if (res) this.redirectToAddvideo(this.courseData.courseId);
            }
          catch {
              this.$bvToast.toast(`Error Occurred.. Course Editing Failed`, {
                  title: "Edit Course",
                  autoHideDelay: 500,
                  appendToast: true
              });
          }
        } else {
            try {
                const res = await liveCourseJs.editLiveCourse(
                    this.courseData,
                    this.getToken
                );
                if (res) this.redirectToSchedule(this.courseData.courseId);
            } catch {
                this.$bvToast.toast(`Error Occurred..  Course Editing Failed`, {
                    title: "Edit Course",
                    autoHideDelay: 500,
                    appendToast: true
                });
            }
        }
      } else {
        if (this.picked === "regular") {
          try{
              const res = await regularCourseJs.addCourse(
                  this.courseData,
                  this.getToken
              );
              if (res) this.redirectToAddvideo(res.bodyText);
          }
          catch {
              this.$bvToast.toast(`Error Occurred.. Add Course Failed`, {
                  title: "Add Course",
                  autoHideDelay: 500,
                  appendToast: true
              });
          }
        } else {
          try {
              const res = await liveCourseJs.addLiveCourse(
                  this.courseData,
                  this.getToken
              );
              if (res) this.redirectToSchedule(res.data.courseId);
          }
            catch {
              this.$bvToast.toast(`Error Occurred.. Add Course Failed`, {
                    title: "Add Course",
                    autoHideDelay: 500,
                    appendToast: true
                });
            }
        }
      }
    },
    addToCourseSpeciality() {
      if (this.text !== "") {
        this.courseData.courseSpeciality.push(this.text);
        this.text = "";
        this.textEmpty = false;
      } else {
        this.textEmpty = true;
      }
    },
    removeFromCourseSpeciality(index) {
      this.courseData.courseSpeciality.splice(index, 1);
    },
    updateProperties(propList) {
      this.courseData.courseProperties = propList;
    },
    uploadCoverImage(event) {
      this.disableButton = true;
      const formData = new FormData();
      formData.append("document", event.target.files[0]);
      fileUploadApis.imageUpload(formData, this.getToken).then(res => {
        this.courseData.imageUrl = res.bodyText;
        this.disableButton = false;
      });
    },
    getCourse() {
      if (this.$route.query.courseId) {
        this.showFile = false;
        this.edit = true;
        this.switched = true;
        this.picked = this.$route.query.courseType;
        if (this.$route.query.courseType === "regular") {
          courseEntityApi
            .getCourseById(this.getToken, this.$route.query.courseId)
            .then(res => {
              this.courseData = res.data;
              this.courseData.courseSpeciality = res.data.courseSpeciality.split(
                ","
              );
            });
        } else {
          liveCourseEntity
            .getLiveCourseByCourseId(this.$route.query.courseId, this.getToken)
            .then(res => {
              this.courseData = res.data;
              this.courseData.courseProperties = res.data.liveCourseProperties;
              this.courseData.courseSpeciality = res.data.courseSpeciality.split(
                ","
              );
            });
        }
      }
    },
    redirectToAddvideo(courseId) {
      this.$router.push({
        path: "/admin/add-video",
        query: {
          courseId: courseId,
          courseName: this.courseData.name,
          totalVideos: this.courseData.totalVideos
        }
      });
    },
    redirectToSchedule(courseId) {
      this.$router.push({
        path: "/admin/live-schedule",
        query: {
          courseId: courseId,
          courseName: this.courseData.name,
          totalSession: this.courseData.totalSession
        }
      });
    },
    resetForm() {
      this.courseData = {
        name: "",
        totalSession: "",
        duration: "",
        imageUrl: "",
        totalVideos: "",
        price: "",
        subject: "",
        description: "",
        courseProperties: [],
        language: "",
        courseSpeciality: [],
        category: null
      };
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
      hideRadio(){
        this.switched = true;
        this.resetForm();

      },
      setCategoryData(){
          this.getCategoryData.forEach(category => {
              this.categories.push({
                  category_name: category.name,
                  category_id: category.category_id
              });
              category.sub_category.forEach(sub => {
                  this.categories.push({
                      category_name: sub.name,
                      category_id: sub.category_id
                  });
                  if (sub.sub_category.length > 0) {
                      sub.sub_category.forEach(cat => {
                          this.categories.push({
                              category_name: cat.name,
                              category_id: cat.category_id
                          });
                      });
                  }
              });
          });
      }
  },
  mounted() {
      this.setCategoryData();
    this.picked = this.$route.query.courseType
      ? this.$route.query.courseType
      : "regular";
    this.resetForm();
    this.getCourse();
  },
    watch:{
      $route(){
          this.setCategoryData();
          this.picked = this.$route.query.courseType
              ? this.$route.query.courseType
              : "regular";
          this.resetForm();
          this.getCourse();
          this.showFile = true;
          this.edit = false;
          this.switched = false;
      }
    }
};
</script>
<style lang="scss">
.add {
  position: absolute;
  right: 1em;
  cursor: pointer;
  transition: all 0.2s linear;
  border-radius: 2em;
  font-size: 0.85em;
  padding: 0.25em 1em;
}
</style>
